/**
 * Supplier e-invoices received by the demo pharmacy — covers every statut
 * + a 2-BL case so the multi-bon-livraison drawer renders.
 */
import { dateOffsetYmd } from "../uuid.js";

export function buildEfactures(fournisseurs, produits) {
  const efactures = [];
  let counter = 1;

  const mk = (frnIdx, daysAgo, statut, statutPaie, items, opts = {}) => {
    const id = `efact-${String(counter).padStart(3, "0")}`;
    const num = `EF-2026-${String(counter + 44).padStart(5, "0")}`;
    const frn = fournisseurs[frnIdx];
    counter += 1;
    const details = items.map((it, i) => {
      const p = produits.find((x) => x.id === it.produit_id);
      const qte = it.quantite;
      const offerte = it.offerte || 0;
      const prixHt = +(p.ppa * 0.6).toFixed(2);
      const prixTtc = +(prixHt * 1.19).toFixed(2);
      const ligneHt = +(qte * prixHt).toFixed(2);
      const ligneTtc = +(qte * prixTtc).toFixed(2);
      return {
        id: `${id}-det-${i + 1}`,
        produit_id: p.id,
        produit: { id: p.id, nom_commercial: p.nom_commercial, ppa: p.ppa, code_barre: p.code_barre },
        numero_lot: `LOT-${id.slice(-3)}-${i + 1}`,
        date_peremption: dateOffsetYmd(540),
        quantite: qte,
        quantite_offerte: offerte,
        prix_achat_ht: prixHt,
        prix_achat_ttc: prixTtc,
        montant_ligne_ht: ligneHt,
        montant_ligne_ttc: ligneTtc,
        remise_pct: 0,
        tva_pct: 19,
      };
    });
    const totalHt = +details.reduce((s, d) => s + d.montant_ligne_ht, 0).toFixed(2);
    const totalTtc = +details.reduce((s, d) => s + d.montant_ligne_ttc, 0).toFixed(2);
    const totalTva = +(totalTtc - totalHt).toFixed(2);
    const paye = statutPaie === "PAYE" ? totalTtc : statutPaie === "PARTIEL" ? +(totalTtc * 0.5).toFixed(2) : 0;

    const bls = opts.bls || [
      { id: `${id}-bl-1`, numero: `BL-${id.slice(-3)}-01`, date: dateOffsetYmd(-daysAgo), montant_ht: totalHt, montant_ttc: totalTtc, statut: statut === "STOCK_VALIDE" ? "VALIDE" : "RECU", accepted_by_pharmacy: statut === "STOCK_VALIDE" },
    ];

    efactures.push({
      id,
      numero: num,
      fournisseur_id: frn.id,
      fournisseur: { id: frn.id, nom: frn.nom, telephone: frn.telephone, email: frn.email },
      type: "FACTURE",
      qr_code: `QR-EF-${counter}-${id}`,
      code_import: `IMPORT-${id.toUpperCase()}`,
      date_emission: dateOffsetYmd(-daysAgo),
      date_reception: statut === "BROUILLON" ? null : dateOffsetYmd(-(daysAgo - 1)),
      date_echeance: dateOffsetYmd(20 - daysAgo),
      statut,
      statut_paiement: statutPaie,
      montant_ht: totalHt,
      montant_tva: totalTva,
      montant_ttc: totalTtc,
      montant_paye: paye,
      reste_a_payer: +(totalTtc - paye).toFixed(2),
      notes: opts.notes || "",
      bons_livraison: bls,
      details,
      created_at: dateOffsetYmd(-daysAgo) + "T09:00:00.000Z",
      updated_at: dateOffsetYmd(-(daysAgo - 1)) + "T09:00:00.000Z",
    });
  };

  // 2 RECUE
  mk(0, 2, "RECUE", "NON_PAYE", [
    { produit_id: "p-001", quantite: 100, offerte: 10 },
    { produit_id: "p-020", quantite: 80, offerte: 5 },
    { produit_id: "p-024", quantite: 60 },
  ], { notes: "Livraison conforme, en attente de validation stock." });
  mk(2, 4, "RECUE", "NON_PAYE", [
    { produit_id: "p-005", quantite: 50 },
    { produit_id: "p-012", quantite: 40 },
    { produit_id: "p-013", quantite: 50, offerte: 5 },
  ]);

  // 2 STOCK_VALIDE
  mk(3, 12, "STOCK_VALIDE", "PARTIEL", [
    { produit_id: "p-202", quantite: 30 },
    { produit_id: "p-203", quantite: 20 },
    { produit_id: "p-204", quantite: 25 },
  ], { notes: "Premier paiement de 50% effectué" });
  mk(1, 18, "STOCK_VALIDE", "NON_PAYE", [
    { produit_id: "p-008", quantite: 60 },
    { produit_id: "p-009", quantite: 80 },
  ]);

  // 1 BROUILLON
  mk(4, 1, "BROUILLON", "NON_PAYE", [
    { produit_id: "p-300", quantite: 100 },
    { produit_id: "p-301", quantite: 60 },
  ], { notes: "Brouillon en cours de saisie côté fournisseur" });

  // 1 PAYEE with 2 BLs
  const id2 = `efact-006`;
  efactures.push({
    id: id2,
    numero: "EF-2026-00050",
    fournisseur_id: fournisseurs[2].id,
    fournisseur: { id: fournisseurs[2].id, nom: fournisseurs[2].nom, telephone: fournisseurs[2].telephone, email: fournisseurs[2].email },
    type: "FACTURE",
    qr_code: "QR-EF-PAYEE",
    code_import: "IMPORT-EF-006",
    date_emission: dateOffsetYmd(-35),
    date_reception: dateOffsetYmd(-34),
    date_echeance: dateOffsetYmd(-5),
    statut: "PAYEE",
    statut_paiement: "PAYE",
    montant_ht: 156800,
    montant_tva: 29792,
    montant_ttc: 186592,
    montant_paye: 186592,
    reste_a_payer: 0,
    notes: "Réglé intégralement",
    bons_livraison: [
      { id: "efact-006-bl-1", numero: "BL-006-01", date: dateOffsetYmd(-34), montant_ht: 90000, montant_ttc: 107100, statut: "VALIDE", accepted_by_pharmacy: true },
      { id: "efact-006-bl-2", numero: "BL-006-02", date: dateOffsetYmd(-30), montant_ht: 66800, montant_ttc: 79492, statut: "VALIDE", accepted_by_pharmacy: true },
    ],
    details: [
      { id: "efact-006-det-1", produit_id: "p-003", produit: { id: "p-003", nom_commercial: "Amoxil 500mg", ppa: 412, code_barre: "6131019034221" }, numero_lot: "LOT-006-1", date_peremption: dateOffsetYmd(420), quantite: 150, quantite_offerte: 10, prix_achat_ht: 247.20, prix_achat_ttc: 294.17, montant_ligne_ht: 37080, montant_ligne_ttc: 44125.50, remise_pct: 0, tva_pct: 19 },
      { id: "efact-006-det-2", produit_id: "p-011", produit: { id: "p-011", nom_commercial: "Augmentin 1g", ppa: 684, code_barre: "6131019100774" }, numero_lot: "LOT-006-2", date_peremption: dateOffsetYmd(390), quantite: 120, quantite_offerte: 0, prix_achat_ht: 410.40, prix_achat_ttc: 488.38, montant_ligne_ht: 49248, montant_ligne_ttc: 58605.12, remise_pct: 0, tva_pct: 19 },
      { id: "efact-006-det-3", produit_id: "p-031", produit: { id: "p-031", nom_commercial: "Ciflox 500mg", ppa: 456, code_barre: "6131019300774" }, numero_lot: "LOT-006-3", date_peremption: dateOffsetYmd(400), quantite: 250, quantite_offerte: 20, prix_achat_ht: 273.60, prix_achat_ttc: 325.58, montant_ligne_ht: 68400, montant_ligne_ttc: 81402.00, remise_pct: 0, tva_pct: 19 },
    ],
    created_at: dateOffsetYmd(-35) + "T09:00:00.000Z",
    updated_at: dateOffsetYmd(-5) + "T09:00:00.000Z",
  });

  return efactures;
}
